import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const FeatureSetBlock = ({
  key,
  icon=null,
  title=null,
  content=null,
  button=null,
  backgroundColor="white",
  features=null
}) => {

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <div className={ `feature-set-block ${backgroundColor === 'gray' ? "bgg1" : "bgw"}` }>
      <div className="container">
        <div className="ph2">
          <div className="row aic">
            {icon &&
            <div className="col-2 col-md-1 pl0 mb2 icon">
              {icon?.formats?.medium &&
              <img src={icon.formats.medium.url.includes(cdnUrl) ? icon.formats.medium.url : cdnUrl + icon.formats.medium.url} alt={ icon.alternativeTest } />
              }
              {!icon?.formats?.medium &&
              <img src={icon.url.includes(cdnUrl) ? icon.url : cdnUrl + icon.url} alt={ icon.alternativeTest } />
              }
            </div>
            }
            <div className={ `col-10 col-xl-11 ${!icon && content ? "pl0" : ""}` }>
              {title &&
              <h2 className={ `content-title ${!icon && content ? "orange-dash" : ""}` }>{ htmlDecode(title) }</h2>
              }
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-5 ph0">
              {content &&
              <div className="section-content" dangerouslySetInnerHTML={{ __html: content }} />
              }
              {button &&
              <Link className="button mb2" href={ button.link } target={ `${button.openNewTab ? "_blank" : "_self"}` }>{ button.text }</Link>
              }
            </div>
            {features &&
            <div className="col-12 col-lg-6 offset-lg-1 ph0 feature-blocks-wrap">
              <div className="row justify-content-between">
                {features.map((feature, index) => (
                    <div className="col-12 col-md-5 col-lg-6 feature-block">
                      <div className="">
                        {feature.title &&
                        <h3 className="teaser-subhead-alt">{ htmlDecode(feature.title) }</h3>
                        }
                        {feature.content &&
                        <div className="copy" dangerouslySetInnerHTML={{ __html: feature.content }} />
                        }
                      </div>
                    </div>
                ))}
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeatureSetBlock
